export const ENVIRONMENTS = {
  PROD: 'production',
};

export const USER_ROLES = {
  GENERAL_ADMIN_ID: 2,
  LOCATION_ADMIN_ID: 3,
} as const;
